let customSelectEnabled = false;

export function enableCustomSelect() {
    customSelectEnabled = true;
}

export function disableCustomSelect() {
    customSelectEnabled = false;
}

export async function getCustomSelect() {
    return (await import('custom-select')).default;
}

/**
 * GravityForms can change the disabled state of a select with conditional formatting.
 * custom-select doesn't keep track of this so it doesn't change the state of it's
 * container.
 *
 * When they don't match, fix it.
 */
function watchConditionalFormatting(customSelectInputs) {
    if (! jQuery) {
        return;
    }

    // We are only interested in selects within a GravityFroms form
    const gravityFormsSelects = customSelectInputs.filter((customSelectInput) => {
        return customSelectInput.container.closest('.ginput_container')
    });

    jQuery(document).on("gform_post_conditional_logic", () => {
        gravityFormsSelects.forEach((customSelectInput) => {
            const containerDisabled = customSelectInput.container.classList.contains('is-disabled');
            const selectDisabled = customSelectInput.select.disabled;

            if (containerDisabled !== selectDisabled) {
                /*
                 * First set the select to match the container. This is because custom-select checks
                 * whether the select is disabled/enabled before changing it.
                 */
                customSelectInput.select.disabled = containerDisabled;
                customSelectInput.disabled = selectDisabled;
            }
        });
    });
}

/**
 * Calls custom-select library. Passes through args after loading the library.
 *
 * @returns {Promise<void>}
 */
export async function applyCustomSelect(...args) {
    if ( ! customSelectEnabled ) {
        return;
    }

    const customSelect = await getCustomSelect();

    const customSelectInputs = customSelect(...args);
    watchConditionalFormatting(customSelectInputs);
}
